let stepsApi = {
    async get(token, companyId, filters){
        let response = await window.axios.get('/api/steps', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...filters
            }
        });
        return response.data;
    }
}

export default stepsApi